export default __webpack_public_path__ + "static/media/indicator-sect5-body.8ad96b9c.svg";